import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/PolicyPage.css';

const PolicyPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Házirend | Pelyák Adél</title>
        <meta name="description" content="Házirend és szolgáltatási feltételek - időpontfoglalás, lemondás, fizetési feltételek." />
        <meta property="og:title" content="Házirend | Pelyák Adél" />
        <meta property="og:description" content="Házirend és szolgáltatási feltételek - időpontfoglalás, lemondás, fizetési feltételek." />
        <meta property="og:type" content="website" />
      </Helmet>
      <Header />
      <main className="policy-page">
        <div className="policy-content">
          <div className="policy-container">
            <h1 className="policy-title">Házirend</h1>
            
            <div className="policy-section">
              <h2>Fizetési feltételek</h2>
              <ul>
                <li>A szolgáltatás ellenértéke a helyszínen készpénzben vagy banki átutalással fizetendő.</li>
                <li>Hitel, részletfizetés nem lehetséges.</li>
              </ul>
              <p><strong>Bejelentkezéseddel automatikusan elfogadod az árlistát és a házirendet.</strong></p>
            </div>

            <div className="policy-section">
              <h2>Időpont módosítása és szolgáltatás csökkentése</h2>
              <ul>
                <li>Az időpontot megelőző 24 órán kivül ingyenesen lemondható vagy módosítható a szolgáltatás. 24 órán belüli lemondás esetén a szolgáltatás TELJES DÍJA felszámolásra kerül, (tehát előző napi vagy aznapi lemondás esetén)</li>
                <li>Ha a lefoglalt időpontban jelzed, hogy az egyik választott szolgáltatásra mégsem tartasz igényt, annak 50%-a felszámításra kerül.</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>Lemondási feltételek</h2>
              <ul>
                <li>A szolgáltatás az időpont előtt minimum 24 órával előtte díjmentesen lemondható.</li>
                <li>24 órán belüli lemondás esetén (tehàt előző nap vagy az aznapi lemondás) a teljes szolgáltatási díj felszámításra kerül.</li>
                <li>Ha az időpontodat lemondás nélkül elmulasztod, kizárólag a kezelés teljes díjának megfizetése után tudok új időpontot biztosítani.</li>
                <li>Hétfői időpont esetén a lemondásra az előző hét szombat 14:00 óráig van lehetőség.</li>
                <li>A lemondási díj készpénzben vagy banki átutalással fizethető.</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>Betegség miatti lemondás</h2>
              <p>
                Amennyiben megbetegszel, kérlek, hogy mielőbb értesíts telefonon vagy üzenetben. Közösen keresünk egy új időpontot a teljes felépülésed után. Ebben az esetben semmilyen díjat nem számolok fel.
              </p>
              <p>
                Fontos azonban, hogy az időpont előtt 1-2 órával történő értesítés már nem elfogadható, így a 24 órás lemondási szabály lép életbe.
              </p>
            </div>

            <div className="policy-section">
              <h2>Késés</h2>
              <ul>
                <li>10-15 percnél hosszabb késés esetén kizárólag egy színezett alap (nude) lakkozást tudok elkészíteni, mintázat és díszítés nélkül – ez érvényes gél lakkozásra és töltésre is.</li>
                <li>Amennyiben a késésed meghaladja a 15 percet, az elmaradt szolgáltatás 100%-ának megfizetése után tudok új időpontot biztosítani.</li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PolicyPage; 